import { render } from "./DxtPackagesManagement.vue?vue&type=template&id=980ca968&scoped=true"
import script from "./DxtPackagesManagement.vue?vue&type=script&lang=js"
export * from "./DxtPackagesManagement.vue?vue&type=script&lang=js"

import "./DxtPackagesManagement.vue?vue&type=style&index=0&id=980ca968&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-980ca968"

export default script